<div *ngFor="let plant of plants$ | async">
    <app-mini-plant [plant]="plant" [routerLink]="['/plants', plant.id]">
        <mat-icon *ngIf="plant.isClose">location_on</mat-icon>
    </app-mini-plant>
</div>

